import React, { useState, useEffect, useRef } from 'react';
import AccommodationSearchForm from 'Views/AccommodationSearch/components/AccommodationSearchForm';
import moment from 'moment';
import { console } from 'window-or-global';
import Cookies from 'js-cookie';
import { useMediaQuery } from 'react-responsive';

import { sendEcommerceEvent } from '../../components/GA4';
import { useOnScreen } from '../../components/useOnScreen';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const API_DATE_FORMAT = 'YYYY-MM-DD';

const AccommodationReservation = () => {
  const widgetElementRef = useRef(null);
  const bookingWidgetIsOnScreen = useOnScreen(widgetElementRef);
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1080px)' });

  const [pets, setPets] = useState(urlParams.get('pets') == 1 ? true : false);
  const [selectedExtras, setSelectedExtras] = useState([]);

  // Check if deadline for same day booking has passed.
  let isBookingDeadline = false;
  const bookingDeadlineValues = drupalSettings.booking_deadline.split(':');
  if (bookingDeadlineValues.length > 1) {
    const bookingDeadline = new Date().setHours(
      bookingDeadlineValues[0],
      bookingDeadlineValues[1],
    );

    if (new Date().getTime() > bookingDeadline) {
      isBookingDeadline = true;
    }
  }

  // Check if the start date in the url params is past booking deadline.
  let initialStartIsPastDeadline = false;
  if (
    isBookingDeadline &&
    urlParams.get('startDate') &&
    moment(urlParams.get('startDate')).isSame(moment(), 'day')
  ) {
    initialStartIsPastDeadline = true;
  }

  const [startDate, setStartDate] = useState(
    !initialStartIsPastDeadline && urlParams.get('startDate')
      ? moment(urlParams.get('startDate'), API_DATE_FORMAT)
      : undefined,
  );
  const [endDate, setEndDate] = useState(
    !initialStartIsPastDeadline && urlParams.get('endDate')
      ? moment(urlParams.get('endDate'), API_DATE_FORMAT)
      : undefined,
  );
  const [adults, setAdults] = useState(parseInt(urlParams.get('adults')) || 2);
  const [children, setChildren] = useState(
    parseInt(urlParams.get('children')) || 0,
  );
  const [infants, setInfants] = useState(
    parseInt(urlParams.get('infants')) || 0,
  );
  const [availability, setAvailability] = useState([]);
  const [availabilityPets, setAvailabilityPets] = useState([]);
  const [availabilityFound, setAvailabilityFound] = useState(true);
  const [loadingAvailabilities, setLoadingAvailabilities] = useState();
  const [loadingAccommodations, setLoadingAccommodations] = useState();
  const [loadingOwnershipInfo, setLoadingOwnershipInfo] = useState(true);
  const [addingToCart, setAddingToCart] = useState(false);
  const [fetchingCampaigns, setFetchingCampaigns] = useState(true);
  const [products, setProducts] = useState({
    data: null,
  });
  const [redirect, setRedirect] = useState();
  // Total price, including additional services.
  const [price, setPrice] = useState();
  // Price for the product.
  const [apiPrice, setApiPrice] = useState();
  const [errorMessage, setErrorMessage] = useState(
    initialStartIsPastDeadline
      ? drupalSettings.min_availability_message
      : undefined,
  );
  const [cartLimitReached, setCartLimitReached] = useState(false);
  const [allCampaigns, setAllCampaigns] = useState();
  const [applicableCampaigns, setApplicableCampaigns] = useState([]);
  // userOwnsApartment: user the is the owner of the current product.
  const [userOwnsApartment, setUserOwnsApartment] = useState(false);
  // userIsOwner: user has any owned rooms.
  const [userIsOwner, setUserIsOwner] = useState(false);
  const [ownersRateplanCode, setOwnersRateplanCode] = useState(null);
  const [quickRateplanCode, setQuickRateplanCode] = useState(null);
  const hotellinxIds = drupalSettings.hotellinx_ids;
  const numberOfNights =
    startDate && endDate
      ? Array.from(moment.range(startDate, endDate).by('day')).length - 1
      : 0;
  const numberOfGuests = adults + children;

  const [email, setEmail] = useState();
  const [ownershipData, setOwnerShipData] = useState();
  const dataLayer = window.dataLayer;
  const [hasQuota, setHasQuota] = useState(true);

  const extraServices = drupalSettings.accommodation_extra_services;

  const getHotellinxIdPets = (value = pets) => {
    // True returns "with pets" id and false "no pets" id.
    if (Object.values(hotellinxIds).includes(true)) {
      return Object.keys(hotellinxIds).find(
        (key) => hotellinxIds[key] === value,
      );
    } else {
      return Object.keys(hotellinxIds).find(
        (key) => hotellinxIds[key] === false,
      );
    }
  };

  const roomAllowsPets = () => {
    return Object.values(hotellinxIds).includes(true);
  };

  async function fetchAvailabilities() {
    const url = new URL('/api/availabilities', process.env.IPS_API_URL);
    url.searchParams.set('resort', drupalSettings.active_site);
    url.searchParams.set('roomTypeId', getHotellinxIdPets());
    setLoadingAvailabilities(true);

    // Fetch availabilities for two months at a time.
    for (let dayStep = 0; dayStep < 558; dayStep = dayStep + 62) {
      const startDate = moment().add(dayStep, 'days').format(API_DATE_FORMAT);
      const endDate = moment().add(dayStep + 62, 'days').format(API_DATE_FORMAT);
      url.searchParams.set('startDate', startDate);
      url.searchParams.set('endDate', endDate);
      await fetch(
        url.href,
        {
          method: 'GET',
        },
      ).then((response) => {
        setLoadingAvailabilities(false);
        if (response.ok) {
          response.json().then((data) => {
            data.map((value) => {
              if (value.roomTypeId == getHotellinxIdPets(false)) {
                setAvailability((oldStateArray) =>
                  [...oldStateArray, value.availability].flat(),
                );
              }
              if (value.roomTypeId == getHotellinxIdPets(true)) {
                setAvailabilityPets((oldStateArray) =>
                  [...oldStateArray, value.availability].flat(),
                );
              }
            });
            setAvailabilityFound(true);
          });
        } else {
          console.log('fetchAvailabilities: error getting data');
          setAvailabilityFound(false);
        }
      });
    }
  }

  useEffect(() => {
    async function checkOwnerShip() {
      // Based on the drupal data, check if the current user owns the apartment.
      if (
        drupalSettings.user.roles &&
        drupalSettings.user.roles.includes('owner')
      ) {
        setLoadingAccommodations(true);
        const response = await fetch(
          `${drupalSettings.base_url}/getOwnershipInfo`,
          {
            method: 'GET',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );

        if (response.ok) {
          const data = await response.json();

          if (data[0] && data[0].field_ownership_info) {
            const ownershipDataJson = JSON.parse(data[0].field_ownership_info);
            const currentRoomId = parseInt(getHotellinxIdPets());

            if (
              ownershipDataJson.rti &&
              ownershipDataJson.rti.includes(currentRoomId)
            ) {
              setUserOwnsApartment(true);
            }
          }
        }
      }
    }

    checkOwnerShip();
  }, [pets]);

  async function getAccommodations() {
    if (userOwnsApartment && startDate && endDate) {
      setLoadingAccommodations(true);
      // We just need to check the quota and get the rateplancodes.
      await Promise.all([
        getQuotaAndRateplanCode(1),
        getQuotaAndRateplanCode(2),
      ]);
      setLoadingAccommodations(false);
      return;
    }

    const roomTypeIds = pets
      ? getHotellinxIdPets()
      : Object.keys(hotellinxIds).toString();

    const url = new URL('/api/accommodations', process.env.IPS_API_URL);
    url.searchParams.set('resort', drupalSettings.active_site);
    url.searchParams.set('roomTypeIds', roomTypeIds);
    urlParams.forEach((value, key) => url.searchParams.append(key, value));
    const API_URL = url.href;

    const headers = {
      method: 'GET',
      headers: {
        token: Cookies.get('mo.id.token.Azure.AD.B2C'),
        email,
      },
    };

    if (hotellinxIds && startDate && endDate) {
      setProducts({ data: null });
      setLoadingAccommodations(true);
      setErrorMessage(null);
      setOwnersRateplanCode(null);
      setQuickRateplanCode(null);
      setPrice(null);

      const response = await fetch(API_URL, headers);
      if (response.ok) {
        const data = await response.json();

        // Sort results by lowest price.
        data.result.sort((a, b) => a.price - b.price);

        if (data.result[0].price) {
          // Price of only the accommodation.
          const priceFromApi = parseFloat(data.result[0].price);
          setApiPrice(priceFromApi);

          let additionalPrice = 0;
          selectedExtras.forEach((extraId) => {
            const extra = extraServices.find(
              (service) => parseInt(service.id) === parseInt(extraId),
            );
            additionalPrice += parseFloat(extra.price);
          });
          // Total price with extra services.
          setPrice(additionalPrice + priceFromApi);
        }

        setProducts({ data: data.result });
        if (data.ownershipData) {
          setOwnerShipData(data.ownershipData);
          checkIfOwner(data.ownershipData);
        }
        const item_category = data.result[0].field_capacity.name;
        const item_category2 = data.result[0].field_housing_type_list[0];
        sendEcommerceEvent(
          dataLayer,
          'view_item',
          true,
          data.result[0].roomName,
          userOwnsApartment ? 0 : data.result[0].price,
          item_category,
          item_category2,
        );
      } else {
        console.log('getAccommodations: error getting data');
        // response.json().then((data) => {
        const data = await response.json();
        // If the user lands on the page but gets an error message,
        // we should still check if he is an owner, so we can display info on the
        // calendar correctly, for example excluding the minimum stay dates.
        if (data.ownershipData && !userIsOwner) {
          checkIfOwner(data.ownershipData);
        }
        switch (response.status) {
          case 452:
            setErrorMessage(
              Drupal.t(
                'Number of guests exceeds the maximum for this room type.',
              ),
            );
            break;

          case 453:
            setErrorMessage(
              Drupal.t(
                'No availability for this period. Please consider a different room type.',
              ),
            );
            break;

          case 454: {
            // Get the minimum stay value from the error message.
            const message = data.error.split('=');
            const minStay = message[1][0];
            setErrorMessage(
              drupalSettings.min_stay_message.replace(/@nights/g, minStay),
            );
            break;
          }
          case 455: {
            // Reservation length exceeds the maximum.
            setErrorMessage(drupalSettings.reservation_length_error_message);
            break;
          }
          case 456:
          case 457: {
            // Reservation contains days that can't be booked online.
            setErrorMessage(
              drupalSettings.continuous_availability_error_message,
            );
            break;
          }

          default:
            setErrorMessage(data.error);
        }
      }

      setLoadingAccommodations(false);
    }
  }

  function filterCampaignExpired({ attributes }) {
    for (let i = 0; i < attributes.field_campaign_validity.length; i++) {
      if (moment(attributes.field_campaign_validity[i].end_value).isAfter()) {
        return true;
      }
    }
    return false;
  }

  function filterCampaignApartmentId({ relationships }) {
    return relationships.field_products.data.some((value) =>
      value.id.includes(drupalSettings.product_uuid),
    );
  }

  function getAllActiveCampaigns() {
    if (allCampaigns) {
      return allCampaigns
        .filter(filterCampaignApartmentId)
        .filter(filterCampaignExpired);
    }
  }

  function disableBooking() {
    if (
      !price ||
      loadingAvailabilities ||
      loadingAccommodations ||
      addingToCart ||
      userOwnsApartment ||
      !availabilityFound ||
      fetchingCampaigns ||
      cartLimitReached
    ) {
      return true;
    }

    return false;
  }

  async function fetchCampaigns() {
    const API_URL = `${drupalSettings.base_url}/${drupalSettings.current_language}/jsonapi/node/campaign`;

    const response = await fetch(API_URL, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    });

    if (response.ok) {
      const { data } = await response.json();
      setAllCampaigns(data);
    }
  }

  function checkIfOwner(data = null) {
    const currentRoomId = getHotellinxIdPets();
    const rooms = data ? data.rooms : ownershipData.rooms;

    setUserIsOwner(
      drupalSettings.user.roles && drupalSettings.user.roles.includes('owner'),
    );

    if (rooms.some((room) => room.roomTypeId == currentRoomId)) {
      setUserOwnsApartment(true);
      return true;
    } else {
      setUserOwnsApartment(false);
      return false;
    }
  }

  // Fetch and filter campaign info.
  useEffect(() => {
    async function getData() {
      await fetchCampaigns();
      setFetchingCampaigns(false);
    }
    getData();
  }, [setAllCampaigns]);
  useEffect(() => {
    getAllActiveCampaigns();
  }, [allCampaigns]);

  // Get the ownership info if the dates aren't set.
  useEffect(() => {
    const fetchOwnerShipInfo = async () => {
      let ownershipData = {};
      const url = new URL('/api/accommodations', process.env.IPS_API_URL);
      url.searchParams.set('resort', drupalSettings.active_site);
      urlParams.forEach((value, key) => url.searchParams.append(key, value));
      const API_URL = url.href;

      const headers = {
        method: 'GET',
        headers: {
          token: Cookies.get('mo.id.token.Azure.AD.B2C'),
          email,
        },
      };
      const accommodationsResponse = await fetch(API_URL, headers);

      if (accommodationsResponse.ok) {
        const accommodationsData = await accommodationsResponse.json();
        if (accommodationsData.ownershipData) {
          ownershipData = accommodationsData.ownershipData;
          checkIfOwner(ownershipData);
        }
      }

      setOwnerShipData(ownershipData);
      setLoadingOwnershipInfo(false);
    };

    // No need to check ownership data if the user isn't an owner.
    if (
      !drupalSettings.user.roles ||
      !drupalSettings.user.roles.includes('owner')
    ) {
      return;
    }

    // Run only if there's no dates, and the user is authenticated.
    if (!startDate && !endDate) {
      if (!ownershipData) {
        fetchOwnerShipInfo();
      }
    }

    if (ownershipData && Object.keys(ownershipData).length > 0) {
      checkIfOwner();
    }
  }, [pets, email, drupalSettings.user]);

  function disableOwnerReservation() {
    if (
      errorMessage ||
      loadingAccommodations ||
      !availabilityFound ||
      addingToCart
    ) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Fetch rates and/or quota for owner.
   */
  async function getQuotaAndRateplanCode(reservationType) {
    const roomTypeIds = pets
      ? getHotellinxIdPets()
      : Object.keys(hotellinxIds).toString();

    const apiUrl = new URL('/api/accommodations', process.env.IPS_API_URL);
    apiUrl.searchParams.set('resort', drupalSettings.active_site);
    apiUrl.searchParams.set('roomTypeIds', roomTypeIds);
    apiUrl.searchParams.set('reservationType', reservationType);
    urlParams.forEach((value, key) => apiUrl.searchParams.append(key, value));
    const API_URL = apiUrl.href;

    const headers = {
      method: 'GET',
      headers: {
        token: Cookies.get('mo.id.token.Azure.AD.B2C'),
        email,
      },
    };

    const response = await fetch(API_URL, headers);

    if (response.ok) {
      const data = await response.json();

      // Owner's reservation.
      if (reservationType === 1) {
        // The ecommerce event is arbitrarily in only one case,
        // we just don't want to send it twice.

        setProducts({ data: data.result });

        const item_category = data.result[0].field_capacity.name;
        const item_category2 = data.result[0].field_housing_type_list[0];
        sendEcommerceEvent(
          dataLayer,
          'view_item',
          true,
          data.result[0].roomName,
          0,
          item_category,
          item_category2,
        );

        if (parseInt(data.result[0].price) !== 0) {
          setHasQuota(false);
        } else {
          setHasQuota(true);
        }
        setOwnersRateplanCode(data.result[0].rateplanCode);
        // Quick reservation.
      } else if (reservationType === 2) {
        setQuickRateplanCode(data.result[0].rateplanCode);
      }
    } else {
      console.log(
        `getAccommodations: error getting data for reservationType ${reservationType}`,
      );
    }
  }

  // Fetch campaigns that this reservation applies to.
  useEffect(() => {
    async function getApplicableCampaigns() {
      const url = new URL(
        `${drupalSettings.base_url}/${drupalSettings.current_language}/api/activecampaigns`,
      );
      url.searchParams.set('startDate', startDate.format(API_DATE_FORMAT));
      url.searchParams.set('endDate', endDate.format(API_DATE_FORMAT));
      url.searchParams.set('purchaseDate', '2025-11-24');
      url.searchParams.set('price', price);
      url.searchParams.set('productId', drupalSettings.product_id);

      const response = await fetch(url.toString());

      if (response.ok) {
        const campaigns = await response.json();
        setApplicableCampaigns(campaigns);
      } else {
        setApplicableCampaigns([]);
      }
    }

    if (!userOwnsApartment && startDate && endDate && price) {
      getApplicableCampaigns();
    }
  }, [startDate, endDate, price]);

  function updateUrlParams() {
    if (startDate && endDate) {
      urlParams.set('startDate', startDate.format(API_DATE_FORMAT));
      urlParams.set('endDate', endDate.format(API_DATE_FORMAT));
    } else {
      urlParams.delete('startDate');
      urlParams.delete('endDate');
    }
    urlParams.set('adults', adults);
    urlParams.set('children', children);
    urlParams.set('infants', infants);
    urlParams.set('pets', pets && roomAllowsPets() ? 1 : 0);

    window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);
  }

  useEffect(() => {
    async function getEmail() {
      const userInfoResponse = await fetch(
        `${drupalSettings.base_url}/getUserInfo`,
      );
      if (userInfoResponse.ok) {
        const userData = await userInfoResponse.json();
        setEmail(userData[0].mail);
      } else {
        setEmail('empty');
        // Ownership info won't be fetched.
        setLoadingOwnershipInfo(false);
      }
    }

    getEmail();
  }, []);

  // Checks if we can add more items to the cart.
  async function checkCart() {
    const response = await fetch(Drupal.url(`cart?_format=json`), {
      credentials: 'include',
    });
    const cartData = await response.json();
    if (!cartData || !cartData[0]) {
      return true;
    }

    let reservationsInCart = 0;
    cartData[0].order_items.forEach((orderItem) => {
      // Counting only reservations towards the limit.
      if (orderItem.purchased_entity.type == 'extra_service') {
        return;
      }
      reservationsInCart++;
    });

    if (reservationsInCart >= drupalSettings.cart_max_items) {
      setCartLimitReached(true);
      setErrorMessage(drupalSettings.cart_limit_message);

      return false;
    }
    return true;
  }

  useEffect(() => {
    async function initializeProduct() {
      // First check that we can still add items to cart.
      const cartOk = await checkCart();

      if (email && cartOk) {
        updateUrlParams();
        setSelectedExtras([]);
        getAccommodations();
      }
    }
    initializeProduct();
  }, [startDate, endDate, pets, adults, children, email]);

  useEffect(() => {
    updateUrlParams();
  }, [children, adults, infants]);

  useEffect(() => {
    fetchAvailabilities();
  }, [setAvailability]);

  useEffect(() => {
    if (redirect) {
      window.location.replace(redirect);
    }
  }, [redirect]);

  // Set selected extra services.
  function onExtraServiceChange(e) {
    if (e.target.checked) {
      setSelectedExtras([...selectedExtras, e.target.value]);
    } else {
      const newExtras = selectedExtras.filter(
        (extra) => extra !== e.target.value,
      );
      setSelectedExtras(newExtras);
    }
  }

  // Update the displayed price.
  useEffect(() => {
    let additionalPrice = 0;
    selectedExtras.map((selectedExtra) => {
      const extra = extraServices.find(
        (service) => parseInt(service.id) === parseInt(selectedExtra),
      );
      additionalPrice += parseFloat(extra.price);
    });

    if (apiPrice) {
      setPrice(apiPrice + additionalPrice);
    }
  }, [selectedExtras, apiPrice]);

  async function addToCart(e, rateplanCodeType) {
    e.preventDefault();

    const cartOk = await checkCart();
    if (!cartOk) {
      return;
    }

    // We want to have one single variation of the correct type.
    let product;
    if (products.data.length == 0) {
      // No products, nothing to do.
      return;
    }
    if (products.data.length == 1) {
      // Either there is only one variation, or travelling with pets.
      product = products.data[0];
    }
    if (products.data.length > 1) {
      // Both pets and non pets in the products; we choose the non pets.
      product = products.data.filter((p) => {
        return p.petApproved == false;
      })[0];
    }

    // Prevent item from accidentally being added twice.
    if (addingToCart) return;
    setAddingToCart(true);

    let rateplanCode = product.rateplanCode
      ? `&rateplanCode=${product.rateplanCode}`
      : '';
    let price = product.price ? `&price=${product.price}` : '';

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },

      body: JSON.stringify([
        {
          purchased_entity_type: 'commerce_product_variation',
          purchased_entity_id: product.variationId,
          quantity: '1',
          combine: false, // False will create another order item, while true will increment an existing item.
        },
      ]),
    };

    const activeRateplanCodeType = () => {
      // The token also has to be added here, since it can be inaccessible to PHP due to caching
      // later when the order price is validated.
      if (rateplanCodeType == 'owner') {
        return `&rateplanCode=${ownersRateplanCode}&reservationType=1`;
      }
      if (rateplanCodeType == 'quick') {
        return `&rateplanCode=${quickRateplanCode}&reservationType=2`;
      }
      return rateplanCode;
    };

    const token = Cookies.get('mo.id.token.Azure.AD.B2C');

    const addToCartResponse = await fetch(
      `${drupalSettings.base_url}/${
        drupalSettings.path.currentLanguage
      }/cart/add?_format=json&adults=${adults}
				&startDate=${startDate.format(API_DATE_FORMAT)}
				&endDate=${endDate.format(API_DATE_FORMAT)}
				&children=${children}
				&infants=${infants}
				&pets=${roomAllowsPets() ? pets : false}
				${userOwnsApartment ? '&price=0' : price}
				${activeRateplanCodeType()}
				${token ? `&token=${token}` : ''}
        ${
          selectedExtras.length > 0
            ? `&extraServices=${selectedExtras.toString()}`
            : ''
        }
        `,
      requestOptions,
    );

    if (addToCartResponse && addToCartResponse.ok) {
      const item_category = product.field_capacity.name;
      const item_category2 = product.field_housing_type_list[0];
      sendEcommerceEvent(
        dataLayer,
        'add_to_cart',
        true,
        product.roomName,
        userOwnsApartment ? 0 : product.price,
        item_category,
        item_category2,
      );

      setRedirect(`/${drupalSettings.path.currentLanguage}/cart`);
    }
  }

  // Calculate benefits. Param 'client' is for public and 'hlx' for Hotellinx use.
  function modifyCampaignCommentString(campaign, target = 'client') {
    let calculatedValue = '';

    const benefitComment =
      target == 'client'
        ? campaign.field_comment_for_client[0]['value']
        : campaign.field_hlx_comment[0]['value'];

    let fieldbenefitItemValue = 0;
    let fieldbenefitItemInternal = 0;

    if (campaign.field_benefit_item_value[0]) {
      fieldbenefitItemValue = campaign.field_benefit_item_value[0].number;
    }

    if (campaign.field_benefit_item_val_internal[0]) {
      fieldbenefitItemInternal =
        campaign.field_benefit_item_val_internal[0].number;
    }

    const benefitItemValue =
      target == 'client' ? fieldbenefitItemValue : fieldbenefitItemInternal;

    const benefitFormula = campaign.field_benefit_formula[0]
      ? campaign.field_benefit_formula[0]['value']
      : null;

    const benefitItemMultiplier =
      campaign.field_benefit_item_multiplier[0]['value'];

    if (benefitFormula === 'nights') {
      calculatedValue =
        numberOfNights * benefitItemValue * benefitItemMultiplier;
    } else if (benefitFormula === 'people') {
      calculatedValue =
        numberOfGuests * benefitItemValue * benefitItemMultiplier;
    } else if (benefitFormula === 'nights_people') {
      calculatedValue = numberOfNights * numberOfGuests * benefitItemValue;
    } else if (benefitFormula === 'per_reservation') {
      calculatedValue = benefitItemMultiplier * benefitItemValue;
    }

    return benefitComment
      .replace(/@items/g, benefitItemMultiplier)
      .replace(/@value/g, calculatedValue);
  }

  async function onFloatingSubmitClick(e) {
    e.preventDefault();

    // If we already have a price, add the item to the cart.
    // Otherwise scrolls to the booking element.
    // For owners, it always scrolls since they usually have two booking options.
    if (!userOwnsApartment && price) {
      await addToCart(e);
      return;
    }

    const bookingWidgetElement = document.getElementById(
      'accommodation_reservation',
    );

    if (bookingWidgetElement) {
      bookingWidgetElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  return (
    <div>
      {/* Fixed button component that can be used to scroll to the booking widget. */}
      <div
        style={{
          display: `${
            bookingWidgetIsOnScreen || !isTabletOrMobile || loadingOwnershipInfo
              ? 'none'
              : 'block'
          }`,
        }}
        className="reservation-anchor-button-container"
      >
        <div style={{ backgroundColor: '#fff' }}>
          <button
            onClick={onFloatingSubmitClick}
            className={`button button--large-full-width ${
              addingToCart ? 'button--disabled' : ''
            }`}
            disabled={addingToCart}
          >
            {userOwnsApartment
              ? Drupal.t('Make booking request')
              : `${Drupal.t('Book this room')} ${
                  price
                    ? new Intl.NumberFormat('fi-FI', {
                        style: 'currency',
                        currency: 'EUR',
                      }).format(parseFloat(price))
                    : ''
                }`}
          </button>
        </div>
      </div>

      {userOwnsApartment && (
        <div className="accommodation-reservation__owner-header">
          <div className="accommodation-reservation__owner-header__home-icon"></div>
          {Drupal.t('Ski-Inn®-owner')}
        </div>
      )}
      <span ref={widgetElementRef}>
        <AccommodationSearchForm
          setPets={setPets}
          pets={pets}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          adults={adults}
          setAdults={setAdults}
          kids={children}
          setChildren={setChildren}
          infants={infants}
          setInfants={setInfants}
          price={price}
          onSubmit={addToCart}
          isSubmitting={addingToCart}
          availableDates={
            availability && pets && roomAllowsPets()
              ? availabilityPets
              : availability
          }
          loadingAvailabilities={loadingAvailabilities}
          loadingAccommodations={loadingAccommodations}
          getAccommodations={getAccommodations}
          maxGuests={products.data ? products.data[0].maxGuests : undefined}
          errorMessage={errorMessage}
          availabilityFound={availabilityFound}
          roomAllowsPets={roomAllowsPets()}
          activeCampaigns={getAllActiveCampaigns()}
          setDatesFirst={true}
          userOwnsApartment={userOwnsApartment}
          userIsOwner={userIsOwner}
          hasQuota={hasQuota}
          ownersRateplanCode={ownersRateplanCode}
          quickRateplanCode={quickRateplanCode}
          disableOwnerReservation={disableOwnerReservation}
          disableBooking={disableBooking}
          extraServices={extraServices}
          onExtraServiceChange={onExtraServiceChange}
          selectedServices={selectedExtras}
        />
      </span>

      {!userOwnsApartment
        ? applicableCampaigns.map((campaign, index) => (
            <div className="active-campaign" key={index}>
              {modifyCampaignCommentString(campaign)}
            </div>
          ))
        : null}
      {selectedExtras.map((extraId) => {
        const extraService = extraServices.find(
          (service) => parseInt(service.id) === parseInt(extraId),
        );

        if (extraService && extraService.description) {
          return (
            <div
              key={extraService.id}
              className="active-extra-service"
              dangerouslySetInnerHTML={{
                __html: extraService.description,
              }}
            ></div>
          );
        }
      })}
    </div>
  );
};

export default AccommodationReservation;
